export default "__VITE_ASSET__Wu$uu3wp__"